import template from './build-year.jade';
import validation from '../../../services/validation';

export default angular
    .module('cian.addForm.buildYear', [])
    .directive('cianAfAboutObjectBuildYear', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller: ['deviceService', function (deviceService) {
            this.isMobile = deviceService.isMobile;
            const currentYear = new Date().getFullYear();
            this.yearMin = currentYear - 250;
            this.yearMax = currentYear + 250;

            this.validationYear = validation(this.form, 'buildYear', {
                parse: 'Введите число',
                min: `Укажите год позднее ${this.yearMin}`,
                max: `Укажите год ранее ${this.yearMax}`,
            });
        }],
        controllerAs: 'buildYear',
        template,
    }))
    .name;
